import styled from 'styled-components'

export const Container = styled.div`
  font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  line-height: ${props => props.theme.texts.bodyMRegular.lineHeight};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};

  p {
    margin: 0;
  }

  & > :nth-child(2) {
    margin-bottom: 0;
  }

  a {
    color: ${props => props.theme.link.color};

    :hover {
      color: ${props => props.theme.link.hover};
    }
    font-weight: 700;
  }
`
